import { call, put, takeLatest } from "redux-saga/effects";
import { getStudentExamAnalysis } from "../../../apis/resultService";
import {
  fetchExamAnalysis,
  fetchExamAnalysisSuccess,
  fetchExamAnalysisError,
} from "./actionCreators";

// fetch exam analysis data
function* fetchExamAnalysisData(api_payload) {
  try {
    const analysisResponse = yield call(getStudentExamAnalysis, api_payload.body);
    const analysisData = yield analysisResponse;
    if (analysisData.output) {
      yield put(fetchExamAnalysisSuccess(analysisData));
    } else {
      yield put(fetchExamAnalysisError("Failed to fetch exam analysis data"));
    }
  } catch (error) {
    yield put(fetchExamAnalysisError(error.message));
  }
}

// Add this to your existing saga watcher or create new watcher
function* examAnalysisSagaWatcher() {
  yield takeLatest(fetchExamAnalysis().type, fetchExamAnalysisData);
}

export default examAnalysisSagaWatcher;
